var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:arrow-left-16-regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.4373 22.3144C35.7854 22.3144 36.1192 22.1761 36.3653 21.9299C36.6115 21.6838 36.7498 21.35 36.7498 21.0019C36.7498 20.6538 36.6115 20.3199 36.3653 20.0738C36.1192 19.8276 35.7854 19.6894 35.4373 19.6894H9.98264L20.564 10.1659C20.6953 10.0516 20.8026 9.91234 20.8796 9.75622C20.9566 9.60009 21.0017 9.43022 21.0124 9.25647C21.0231 9.08273 20.9991 8.9086 20.9419 8.74421C20.8847 8.57981 20.7953 8.42845 20.679 8.29893C20.5627 8.1694 20.4218 8.0643 20.2645 7.98975C20.1072 7.9152 19.9367 7.87268 19.7628 7.86467C19.5889 7.85666 19.4152 7.88332 19.2517 7.9431C19.0882 8.00288 18.9382 8.09458 18.8105 8.21287L5.68551 20.0254C5.54846 20.1485 5.43885 20.299 5.36381 20.4673C5.28878 20.6355 5.25 20.8177 5.25 21.0019C5.25 21.1861 5.28878 21.3682 5.36381 21.5365C5.43885 21.7047 5.54846 21.8553 5.68551 21.9784L18.8105 33.7909C18.9382 33.9092 19.0882 34.0009 19.2517 34.0606C19.4152 34.1204 19.5889 34.1471 19.7628 34.1391C19.9367 34.131 20.1072 34.0885 20.2645 34.014C20.4218 33.9394 20.5627 33.8343 20.679 33.7048C20.7953 33.5753 20.8847 33.4239 20.9419 33.2595C20.9991 33.0951 21.0231 32.921 21.0124 32.7473C21.0017 32.5735 20.9566 32.4036 20.8796 32.2475C20.8026 32.0914 20.6953 31.9521 20.564 31.8379L9.98264 22.3144H35.4373Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.5eb42753830a5b57215c95469f784c0d.svg";
export { ForwardRef as ReactComponent };